export default __webpack_public_path__ + "static/media/b-12.09de64cd.png";